var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorPageBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 574,
    height: 272,
    viewBox: "0 0 574 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1119_35606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.627 128.722H338.641V120.698H327.627V128.722Z",
    fill: "#CFE7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.663 123.244H321.241V226.145H346.663V123.244Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.61 168.26V174.327H353.432V186.512H359.632V271.16H327.193V168.26H351.61Z",
    fill: "#91CCF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.26 97.0508H279.62V98.1586H290.26V97.0508Z",
    fill: "#F8FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.921 98.1689H276.96V116.753H292.921V98.1689Z",
    fill: "#B5DCF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.213 155.599H311.345V63.6206H309.213V155.599Z",
    fill: "#BADEF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.964 155.599H316.096V63.6206H313.964V155.599Z",
    fill: "#BADEF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.624 90.4141H287.611V192.901H321.624V90.4141Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.091 97.8164H304.193V102.527H307.091V97.8164Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.091 105.705H304.193V110.416H307.091V105.705Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.312 113.595H310.414V118.305H313.312V113.595Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.34 158.104H305.125V127.262L343.34 158.104Z",
    fill: "#E4F1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.478 117.437H262.489V271.172H308.478V117.437Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.307 155.577H303.158V271.171H345.307V155.577Z",
    fill: "#BADEF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.905 168.26H299.483V271.16H324.905V168.26Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.271 112.933H262.489V117.436H290.271V112.933Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.545 199.237H326.396V195.003H304.545V199.237Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.545 206.961H326.396V202.726H304.545V206.961Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.545 214.694H326.396V210.46H304.545V214.694Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.545 222.418H326.396V218.184H304.545V222.418Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.545 230.162H326.396V225.928H304.545V230.162Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.545 237.886H326.396V233.651H304.545V237.886Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.545 245.62H326.396V241.386H304.545V245.62Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.545 253.344H326.396V249.109H304.545V253.344Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.545 261.066H326.396V256.832H304.545V261.066Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.403 46.124H407.247V147.917H420.403V46.124Z",
    fill: "#93CDF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.017 49.9648H397.092V175.746H445.017V49.9648Z",
    fill: "#BADEF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.96 65.1738H428.197V71.7378H430.96V65.1738Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.587 65.8057H432.824V72.3696H435.587V65.8057Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.241 73.6113H423.477V80.1753H426.241V73.6113Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.587 73.6113H432.824V80.1753H435.587V73.6113Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.96 82.0498H428.197V88.6137H430.96V82.0498Z",
    fill: "#CFE7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.241 91.1191H423.477V97.6831H426.241V91.1191Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.96 90.4873H428.197V97.0512H430.96V90.4873Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.587 90.4873H432.824V97.0512H435.587V90.4873Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.241 107.363H423.477V113.927H426.241V107.363Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.587 107.363H432.824V113.927H435.587V107.363Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.96 115.801H428.197V122.365H430.96V115.801Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.587 115.801H432.824V122.365H435.587V115.801Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.241 124.239H423.477V130.803H426.241V124.239Z",
    fill: "#CFE7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.96 132.677H428.197V139.241H430.96V132.677Z",
    fill: "#CFE7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.689 146.561H400.394V143.869H391.689V146.561Z",
    fill: "#E4F1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.582 147.141H401.502V145.971H390.582V147.141Z",
    fill: "#E4F1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.849 166.75H404.234V147.141H387.849V166.75Z",
    fill: "#93CDF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.211 271.162V120.367L405.052 94.9191H387.559V90.4258H386.886V130.255H383.305V103.481H364.032V130.255H360.802V171.543H357.179V271.162H452.211Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.844 100.199V271.162H452.211V120.367L414.844 100.199Z",
    fill: "#BADEF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.584 137.254H384.319V271.163H406.584V137.254Z",
    fill: "#EDF5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.734 150.402H400.901V235.682H402.734V150.402Z",
    fill: "#9CD1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.676 150.402H396.844V235.682H398.676V150.402Z",
    fill: "#9CD1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.608 150.402H392.776V235.682H394.608V150.402Z",
    fill: "#9CD1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.551 150.402H388.719V235.682H390.551V150.402Z",
    fill: "#9CD1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.073 134.489H415.206V150.361H428.073V134.489Z",
    fill: "#BADEF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.844 158.135H252.335V271.161H268.844V158.135Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.39 170.518H241.239V155.195H212.39V170.518Z",
    fill: "#CFE7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.044 147.295H224.977V131.972H216.044V147.295Z",
    fill: "#91CCF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.737 152.316H233.393V140.659H221.737V152.316Z",
    fill: "#91CCF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.765 145.877H211.573V104.909H210.765V145.877Z",
    fill: "#91CCF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.265 140.369H232.73V271.161H263.265V140.369Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.797 42.3135H285.572V23.4499L269.797 23.4499V42.3135Z",
    fill: "#91CCF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.096 271.161L194.929 152.513H197.123V140.359L233.248 136.01V159.957H237.512V29.5067H245.514V0H247.77V29.5067H288.853V156.965H293.469V271.161H193.096Z",
    fill: "#BFE1F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.243 85.6836H275.386V92.465H278.243V85.6836Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.036 86.3359H280.179V93.1173H283.036V86.3359Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.378 94.4111H270.521V101.192H273.378V94.4111Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.036 94.4111H280.179V101.192H283.036V94.4111Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.243 103.129H275.386V109.91H278.243V103.129Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.378 112.498H270.521V119.279H273.378V112.498Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.378 221.663H270.521V228.444H273.378V221.663Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.378 239.739H270.521V246.521H273.378V239.739Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.243 111.846H275.386V118.627H278.243V111.846Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.036 111.846H280.179V118.627H283.036V111.846Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.378 129.291H270.521V136.072H273.378V129.291Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.036 129.291H280.179V136.072H283.036V129.291Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.243 138.009H275.386V144.79H278.243V138.009Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.036 138.009H280.179V144.79H283.036V138.009Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.036 175.125H280.179V181.906H283.036V175.125Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.036 192.56H280.179V199.341H283.036V192.56Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.036 201.277H280.179V208.059H283.036V201.277Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.378 146.727H270.521V153.508H273.378V146.727Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.243 155.443H275.386V162.225H278.243V155.443Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.524 165.393H204.762V269.453H227.524V165.393Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.418 133.36H247.946V141.684H252.418V133.36Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.159 147.327H206.687V155.651H211.159V147.327Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.007 183.159H214.657V178.19H199.007V183.159Z",
    fill: "#EDF5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.007 192.239H214.657V187.27H199.007V192.239Z",
    fill: "#EDF5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.007 201.298H214.657V196.328H199.007V201.298Z",
    fill: "#EDF5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.007 210.378H214.657V205.408H199.007V210.378Z",
    fill: "#EDF5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.007 219.447H214.657V214.478H199.007V219.447Z",
    fill: "#EDF5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.007 228.517H214.657V223.547H199.007V228.517Z",
    fill: "#EDF5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.007 237.597H214.657V232.627H199.007V237.597Z",
    fill: "#EDF5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.007 246.666H214.657V241.696H199.007V246.666Z",
    fill: "#EDF5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.007 255.735H214.657V250.766H199.007V255.735Z",
    fill: "#EDF5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.294 43.1836H248.795V269.453H288.294V43.1836Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.524 58.2373H290.436V55.297H268.524V58.2373Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.524 63.6006H290.436V60.6603H268.524V63.6006Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.524 68.9834H290.436V66.0431H268.524V68.9834Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.524 74.3467H290.436V71.4064H268.524V74.3467Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.524 79.7197H290.436V76.7794H268.524V79.7197Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.524 85.083H290.436V82.1427H268.524V85.083Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.524 90.4463H290.436V87.506H268.524V90.4463Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.524 95.8193H290.436V92.879H268.524V95.8193Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.524 101.183H290.436V98.2423H268.524V101.183Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.524 106.39H290.436V103.449H268.524V106.39Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.524 111.753H290.436V108.813H268.524V111.753Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.524 117.115H290.436V114.175H268.524V117.115Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.524 122.489H290.436V119.549H268.524V122.489Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.524 127.852H290.436V124.911H268.524V127.852Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.524 133.226H290.436V130.285H268.524V133.226Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.524 138.599H290.436V135.658H268.524V138.599Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.524 143.972H290.436V141.031H268.524V143.972Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.524 149.335H290.436V146.395H268.524V149.335Z",
    fill: "#CBE6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.865 156.954H525.382V154.252H519.865V156.954Z",
    fill: "#E4F1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.161 157.545H526.086V156.375H519.161V157.545Z",
    fill: "#E4F1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.432 160.599H527.814V157.544H517.432V160.599Z",
    fill: "#E4F1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.976 127.634H523.27L522.804 113.554H522.442L521.976 127.634Z",
    fill: "#E4F1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.158 127.406V154.853H524.088V127.406H521.158ZM522.825 139.478H523.218V153.672H522.825V139.478ZM522.038 139.478H522.432V153.672H522.038V139.478Z",
    fill: "#E4F1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.327 263.396H530.371V140.834H509.327V263.396Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.422 157.875H522.266V146.435H517.422V157.875Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.132 163.859H519.088V270.984H540.132V163.859Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.712 196.369H507.816V270.985H535.712V196.369Z",
    fill: "#BADEF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.075 163.859H528.166V197.839H531.075V163.859Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.61 163.859H540.142V160.018H515.61V163.859Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.322 160.889V79.1088H494.753V75.216H493.501V74.6155H492.994V73.5388H492.062V65.4322H491.462L491.13 58.3506H490.872L490.54 65.4322H489.94V73.5388H489.009V74.6155H488.501V75.216H487.249V79.1088H471.764L462.831 91.7294V160.889H500.332H500.322ZM490.851 73.2385H490.572V65.9706H490.851V73.2385ZM491.42 73.2385H491.141V65.9706H491.42V73.2385Z",
    fill: "#B5DCF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.449 101.699H457.935V117.54H475.449V101.699Z",
    fill: "#93CDF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.482 127.583H445.607V221.88H478.482V127.583Z",
    fill: "#93CDF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.832 131.093L445.607 127.583H478.482L452.832 131.093Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.17 94.6387V121.039H493.677V110.862H484.123V106.628H479.041V110.862H455.016C454.933 111.028 454.861 111.193 454.768 111.349V156.623H444.707V271.172H512.774V94.6387H511.17Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.56 164.575H441.694V167.112H459.56V164.575Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.56 171.19H441.694V173.727H459.56V171.19Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.56 177.216H441.694V179.752H459.56V177.216Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.56 183.241H441.694V185.778H459.56V183.241Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.56 189.268H441.694V191.804H459.56V189.268Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.56 195.293H441.694V197.83H459.56V195.293Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.56 201.329H441.694V203.866H459.56V201.329Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.56 207.354H441.694V209.891H459.56V207.354Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.56 213.38H441.694V215.916H459.56V213.38Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.56 219.405H441.694V221.942H459.56V219.405Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.56 225.431H441.694V227.967H459.56V225.431Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.774 121.019H466.692V271.171H512.774V121.019Z",
    fill: "#CFE7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.815 154.149H491.286V159.533H494.815V154.149Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.746 154.656H497.217V160.04H500.746V154.656Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.771 161.065H485.241V166.449H488.771V161.065Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.815 167.991H491.286V173.375H494.815V167.991Z",
    fill: "#CFE7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.815 127.521H491.286V132.904H494.815V127.521Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.815 141.362H491.286V146.746H494.815V141.362Z",
    fill: "#CFE7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.815 174.907H491.286V180.291H494.815V174.907Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.746 148.631H497.217V154.015H500.746V148.631Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.771 224.074H485.241V229.458H488.771V224.074Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.746 188.749H497.217V194.133H500.746V188.749Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.815 195.665H491.286V201.049H494.815V195.665Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.746 195.665H497.217V201.049H500.746V195.665Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.771 202.581H485.241V207.965H488.771V202.581Z",
    fill: "#CFE7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.815 224.292H491.286V229.676H494.815V224.292Z",
    fill: "#CFE7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.746 209.508H497.217V214.891H500.746V209.508Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.771 231.829H485.241V237.213H488.771V231.829Z",
    fill: "#CFE7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.746 238.745H497.217V244.129H500.746V238.745Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.893 142.999H505.363V148.383H508.893V142.999Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.893 156.841H505.363V162.224H508.893V156.841Z",
    fill: "#CFE7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.893 130.212H505.363V135.596H508.893V130.212Z",
    fill: "#CFE7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.893 163.757H505.363V169.141H508.893V163.757Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.893 184.515H505.363V189.898H508.893V184.515Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.893 213.142H505.363V218.525H508.893V213.142Z",
    fill: "#CFE7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.855 244.543H272.384V239.159H268.855V244.543Z",
    fill: "#C2E1F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M262.913 244.025H266.443V238.642H262.913V244.025Z",
    fill: "#55B1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.889 237.616H278.419V232.233H274.889V237.616Z",
    fill: "#C2E1F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.855 230.711H272.384V225.327H268.855V230.711Z",
    fill: "#8CCAF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.855 271.161H272.384V265.777H268.855V271.161Z",
    fill: "#C2E1F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.855 257.329H272.384V251.945H268.855V257.329Z",
    fill: "#8CCAF1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M268.855 223.785H272.384V218.401H268.855V223.785Z",
    fill: "#55B1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.913 250.062H266.443V244.678H262.913V250.062Z",
    fill: "#C2E1F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.889 174.607H278.419V169.224H274.889V174.607Z",
    fill: "#C2E1F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.913 209.942H266.443V204.559H262.913V209.942Z",
    fill: "#C2E1F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.855 203.026H272.384V197.643H268.855V203.026Z",
    fill: "#C2E1F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M262.913 203.026H266.443V197.643H262.913V203.026Z",
    fill: "#55B1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.889 196.101H278.419V190.717H274.889V196.101Z",
    fill: "#8CCAF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.855 174.399H272.384V169.016H268.855V174.399Z",
    fill: "#8CCAF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.913 189.185H266.443V183.801H262.913V189.185Z",
    fill: "#C2E1F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.889 166.862H278.419V161.479H274.889V166.862Z",
    fill: "#8CCAF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.913 159.937H266.443V154.553H262.913V159.937Z",
    fill: "#C2E1F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.706 197.043H369.176V202.427H372.706V197.043Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.637 197.55H375.107V202.933H378.637V197.55Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.671 203.959H363.141V209.343H366.671V203.959Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.706 210.874H369.176V216.258H372.706V210.874Z",
    fill: "#CFE7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.706 170.414H369.176V175.798H372.706V170.414Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.706 184.256H369.176V189.64H372.706V184.256Z",
    fill: "#CFE7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.706 217.801H369.176V223.184H372.706V217.801Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.637 191.524H375.107V196.908H378.637V191.524Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.637 231.633H375.107V237.016H378.637V231.633Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.706 238.559H369.176V243.942H372.706V238.559Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.637 238.559H375.107V243.942H378.637V238.559Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.671 245.475H363.141V250.858H366.671V245.475Z",
    fill: "#CFE7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.637 252.391H375.107V257.774H378.637V252.391Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.422 143.464H113.922V145.472H120.422V143.464Z",
    fill: "#E4F1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.251 145.037H113.094V145.907H121.251V145.037Z",
    fill: "#E4F1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.29 145.907H111.055V160.557H123.29V145.907Z",
    fill: "#93CDF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.707 271.161V158.528L75.4995 165.92H88.5624V136.165H89.0696V165.92H91.7401V145.918H106.138V165.92H108.55V196.752H111.262V271.161H70.707Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.293 171.139H94.6694V271.161H111.293V171.139Z",
    fill: "#EDF5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.547 233.434H98.9133L98.9133 169.73H97.547L97.547 233.434Z",
    fill: "#9CD1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.569 233.434H101.936L101.936 169.73H100.569L100.569 233.434Z",
    fill: "#9CD1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.602 233.434H104.969L104.969 169.73H103.602L103.602 233.434Z",
    fill: "#9CD1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.645 233.434H108.012L108.012 169.73H106.645L106.645 233.434Z",
    fill: "#9CD1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9944 271.171H125.95L125.95 100.177H95.9944L95.9944 271.171Z",
    fill: "#91CCF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3544 111.38H110.217V95.5394H98.3544V111.38Z",
    fill: "#93CDF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1537 223.701H74.2782V163.218L56.1537 223.701Z",
    fill: "#E4F1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3802 189.257H70.645L70.645 94.9596H48.3802L48.3802 189.257Z",
    fill: "#91CCF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7593 98.4791L70.6553 94.959H48.3905L65.7593 98.4791Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4047 156.209H82.7452V155.205H72.4047V156.209Z",
    fill: "#F8FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1792 271.161V94.6387H35.9176V121.039H39.3542V110.862H45.8235V101.865H49.2703V110.862H65.7076V156.623H75.6445V187.983H84.981V215.927H88.0966V157.307L91.6988 132.262L104.441 132.676L106.904 149.314V271.161H29.1792Z",
    fill: "#CFE7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4634 121.07H41.3726V270.322H43.4634V121.07Z",
    fill: "#91CCF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.111 121.07H46.0201V270.322H48.111V121.07Z",
    fill: "#91CCF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7586 196.142H50.6677V270.322H52.7586V196.142Z",
    fill: "#91CCF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4164 196.142H55.3256V270.322H57.4164V196.142Z",
    fill: "#91CCF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.202 133.773H100.808V121.919H91.202V133.773Z",
    fill: "#BADEF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6644 192.643H48.6389V271.161H62.6644V192.643Z",
    fill: "#91CCF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.062 75.6504H115.641V271.161H141.062V75.6504Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.639 64.459H181.773V61.0735L148.639 61.0735V64.459Z",
    fill: "#B5DCF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.639 70.6504H181.773V67.2649H148.639V70.6504Z",
    fill: "#B5DCF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.639 76.8311H181.773V73.4456H148.639V76.8311Z",
    fill: "#B5DCF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.639 83.0117H181.773V79.6262H148.639V83.0117Z",
    fill: "#B5DCF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.639 89.1924H181.773V85.8069H148.639V89.1924Z",
    fill: "#B5DCF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.639 95.3838H181.773V91.9983H148.639V95.3838Z",
    fill: "#B5DCF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.639 101.575H181.773V98.1897H148.639V101.575Z",
    fill: "#B5DCF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.639 107.745H181.773V104.36H148.639V107.745Z",
    fill: "#B5DCF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.639 113.937H181.773V110.551H148.639V113.937Z",
    fill: "#B5DCF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.243 271.161H178.533L179.102 56.9631L119.243 49.7676V271.161Z",
    fill: "#B5DCF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.243 271.161H131.27L131.954 56.4972L119.243 49.7676V271.161Z",
    fill: "#77C0EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.954 56.4972L179.102 56.9631L119.243 49.7676L131.954 56.4972Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.876 271.161V123.99H165.263L178.377 139.758V271.161H140.876Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.377 139.758L165.263 123.99H140.876L178.377 139.758Z",
    fill: "#BADEF5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M158.069 164.409H156.278V271.172H158.069V164.409Z",
    fill: "#E4F1F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M162.054 164.409H160.263V271.172H162.054V164.409Z",
    fill: "#E4F1F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M166.039 164.409H164.248V271.172H166.039V164.409Z",
    fill: "#E4F1F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M170.024 164.409H168.234V271.172H170.024V164.409Z",
    fill: "#E4F1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.034 271.161H148.629V168.064H134.034V271.161Z",
    fill: "#CFE7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.653 271.171H188.666L188.666 138.857H177.653L177.653 271.171Z",
    fill: "#CFE7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.954 248.508H111.272V243H108.954V248.508Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.062 247.99H107.38V242.482H105.062V247.99Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.918 241.437H115.237V235.929H112.918V241.437Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.954 234.354H111.272V228.847H108.954V234.354Z",
    fill: "#CFE7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.954 227.273H111.272V221.766H108.954V227.273Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.062 227.273H107.38V221.766H105.062V227.273Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.918 213.1H115.237V207.592H112.918V213.1Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.062 213.1H107.38V207.592H105.062V213.1Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.954 178.499H111.272V172.991H108.954V178.499Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.062 177.961H107.38V172.453H105.062V177.961Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.918 171.407H115.237V165.899H112.918V171.407Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.954 164.325H111.272V158.817H108.954V164.325Z",
    fill: "#CFE7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.954 157.244H111.272V151.736H108.954V157.244Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.062 157.244H107.38V151.736H105.062V157.244Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.918 143.07H115.237V137.562H112.918V143.07Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.062 143.07H107.38V137.562H105.062V143.07Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.954 206.018H111.272V200.51H108.954V206.018Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.062 206.018H107.38V200.51H105.062V206.018Z",
    fill: "#A1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.918 198.937H115.237V193.429H112.918V198.937Z",
    fill: "#CFE7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.954 191.845H111.272V186.337H108.954V191.845Z",
    fill: "#CFE7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.062 191.845H107.38V186.337H105.062V191.845Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.518 238.404H267.851C268.896 264.412 299.566 270.53 299.566 270.53H230.587C230.587 270.53 201.564 264.412 200.518 238.404Z",
    fill: "#4E5683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.339 238.404H290.53C291.575 264.412 322.245 270.53 322.245 270.53H243.712C243.712 270.53 208.385 264.412 207.339 238.404Z",
    fill: "url(#paint0_linear_1119_35606)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.742 243.86H380.262C384.34 243.86 392.445 240.547 392.238 236.468L377.757 45.9996C377.55 41.9205 374.082 38.6074 369.994 38.6074H110.144C106.066 38.6074 100.332 43.0697 100.539 47.1592L109.979 236.478C110.186 240.557 113.653 243.871 117.742 243.871V243.86Z",
    fill: "#4E5683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.365 242.711H385.541C389.619 242.711 392.766 239.398 392.569 235.319L383.129 45.9996C382.922 41.9205 379.454 38.6074 375.366 38.6074H111.19C107.111 38.6074 103.965 41.9205 104.161 45.9996L113.601 235.319C113.808 239.408 117.276 242.711 121.365 242.711Z",
    fill: "#4E5683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.365 242.711H385.541C389.619 242.711 392.766 239.398 392.569 235.319L391.016 204.135H112.049L113.601 235.319C113.808 239.408 117.276 242.711 121.365 242.711Z",
    fill: "url(#paint1_linear_1119_35606)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.872 195.179L373.544 48.3086H113.974L121.302 195.179H380.872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.024 245.578C70.024 245.578 72.56 214.094 66.7324 206.857C61.8054 200.738 65.2212 191.596 66.3805 188.936C66.5875 188.47 66.5461 187.931 66.277 187.497C65.0452 185.55 61.8365 179.773 63.5961 174.803C65.2212 170.238 68.6888 167.608 70.3242 166.583C70.8418 166.252 71.1109 165.641 71.0177 165.04C70.2725 160.547 68.5232 142.864 85.9748 138.826C86.6269 138.671 87.2894 138.981 87.631 139.551C88.6764 141.3 90.7673 145.452 91.4815 151.654C92.2164 158.042 89.2561 163.653 87.7966 165.983C87.3929 166.624 87.4964 167.453 88.0657 167.95C89.8461 169.534 93.1377 173.282 91.6057 178.417C90.0841 183.531 88.3038 186.43 87.486 187.59C87.2066 187.983 87.1341 188.47 87.279 188.925C87.9829 191.213 89.7633 198.43 87.0306 205.294C83.7287 213.587 71.1937 246.292 72.0425 261.553C72.0425 261.553 71.0488 257.691 70.024 245.578Z",
    fill: "#319188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8115 146.404C83.8115 146.404 74.506 170.703 70.0654 242.047",
    stroke: "#21295B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4357 235.95C72.4357 235.95 70.3345 210.564 75.2615 202.871C79.4329 196.349 74.9199 187.538 73.4398 185.001C73.181 184.556 73.1603 184.018 73.388 183.562C74.3817 181.502 76.8659 175.497 74.5162 170.714C72.3529 166.304 68.5748 163.995 66.8255 163.115C66.2769 162.835 65.9353 162.276 65.956 161.665C66.1527 157.172 65.8008 139.385 47.9351 136.859C47.2623 136.766 46.6102 137.138 46.3307 137.76C45.4923 139.613 43.9396 143.909 43.981 150.09C44.0121 156.52 47.6556 161.852 49.3842 164.036C49.85 164.626 49.8397 165.475 49.3221 166.034C47.7384 167.774 44.954 171.77 47.0863 176.729C49.229 181.709 51.3612 184.442 52.3135 185.519C52.6241 185.871 52.7483 186.337 52.6655 186.803C52.2514 189.132 51.3302 196.473 54.8806 203.078C59.1658 211.04 67.8917 240.992 68.8957 256.242C68.8957 256.242 72.8705 248.094 72.4357 235.96V235.95Z",
    fill: "#4FAE86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7811 185.529C44.9851 168.612 31.0424 165.309 26.5915 164.678C25.7427 164.553 24.9561 165.144 24.8526 165.993C24.5627 168.25 24.7698 172.691 29.7175 176.232L35.0275 180.031C35.8038 180.591 35.8763 181.688 35.2035 182.382C33.3817 184.256 31.2598 188.231 38.0914 193.522C44.3433 198.367 47.9041 201.483 49.6327 203.067C50.3158 203.699 50.2848 204.765 49.5913 205.376C47.6349 207.084 44.7884 210.77 49.5706 215.222C56.2055 221.393 67.4777 246.748 68.7612 257.815C68.7612 257.815 68.8026 205.946 55.7811 185.529Z",
    fill: "#6CE08B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4842 171.563C95.2802 154.646 109.223 151.343 113.674 150.712C114.523 150.588 115.309 151.178 115.413 152.027C115.703 154.284 115.496 158.725 110.548 162.266L105.238 166.066C104.461 166.625 104.389 167.722 105.062 168.416C106.884 170.29 109.006 174.265 102.174 179.556C95.922 184.401 92.3613 187.518 90.6327 189.102C89.9495 189.733 89.9805 190.8 90.6741 191.41C92.6304 193.119 95.4769 196.804 90.6948 201.256C84.0598 207.427 72.7877 232.782 71.5042 243.849C71.5042 243.849 71.4627 191.98 84.4842 171.563Z",
    fill: "#6CE08B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8458 242.047C78.3772 226.58 80.7475 213.918 89.5251 199.143C94.7213 190.405 100.673 173.499 118.218 163.466C119.274 162.866 120.578 163.663 120.547 164.874C120.402 169.73 119.563 179.897 115.258 184.287C112.96 186.626 111.562 188.003 110.703 188.811C110.061 189.411 110.051 190.405 110.672 191.037C112.494 192.859 114.843 196.918 108.177 202.477C102.112 207.54 98.458 210.418 96.6776 211.805C95.9841 212.334 95.8806 213.317 96.4292 214C97.9404 215.895 99.8864 219.798 94.6281 223.629C83.8011 231.497 74.6405 244.263 68.7405 257.556L71.8665 242.058L71.8458 242.047Z",
    fill: "#4FAE86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.055 253.902C73.5433 189.174 50.3262 143.713 50.3262 143.713",
    stroke: "#21295B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.231 169.306C116.231 169.306 78.9672 215.771 70.7589 252.701",
    stroke: "#21295B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0104 270.332H62.0745C57.665 270.332 53.9283 267.071 53.3487 262.692L48.8771 229.271H95.2078L90.7362 262.692C90.1462 267.061 86.4199 270.332 82.0104 270.332Z",
    stroke: "#21295B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0134 252.764L53.3383 262.692C53.9283 267.072 57.6547 270.333 62.0642 270.333H82C86.4095 270.333 90.1462 267.072 90.7259 262.692L92.0508 252.764H52.0134Z",
    fill: "#4E5683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.313 221.279H45.927V228.982H98.313V221.279Z",
    stroke: "#21295B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.675 90.5703H178.005C176.073 90.5703 174.506 92.137 174.506 94.0697V110.863C174.506 112.795 176.073 114.362 178.005 114.362H326.675C328.607 114.362 330.174 112.795 330.174 110.863V94.0697C330.174 92.137 328.607 90.5703 326.675 90.5703Z",
    stroke: "#4E5683",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M360.429 131.185C359.695 131.672 358.887 132.014 358.049 132.272C350.255 134.726 338.258 127.903 330.298 115.925C322.338 103.946 320.692 90.2384 325.971 84.0057C326.541 83.3328 327.162 82.7219 327.897 82.2353C335.411 77.2451 349.209 84.2231 358.018 97.496C366.826 110.769 367.934 126.185 360.419 131.185H360.429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.533 148.465C376.794 145.949 375.49 146.425 374.486 146.104C373.472 145.783 371.433 147.326 371.039 148.838C370.646 150.349 370.325 150.37 370.501 151.519C370.677 152.658 373.793 152.534 375.242 152.472C376.691 152.399 381.162 153.289 381.162 153.289L385.417 148.527L378.533 148.486V148.465Z",
    fill: "#FEC4AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.407 147.761C379.154 145.514 378.119 146.405 376.567 146.995C375.014 147.585 372.84 148.91 372.84 148.91C372.84 148.91 372.488 150.308 373.523 150.66C374.558 151.012 377.467 149.749 378.036 151.56C378.595 153.372 385.417 148.506 385.417 148.506L380.407 147.761Z",
    fill: "#FEC4AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.578 117.405C421.013 116.867 418.053 119.507 415.61 131.102C413.675 140.275 409.545 147.098 409.545 147.098L381.494 147.574L379.693 153.186C379.693 153.186 407.578 158.507 413.519 157.71C421.728 156.602 426.003 142.563 430.039 131.63C432.896 123.886 431.799 118.14 425.578 117.405Z",
    fill: "#0F2E40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.739 105.551C394.784 108.016 395.509 110.366 396.492 111.888C397.475 113.41 396.803 116.422 396.43 117.779C396.047 119.125 399.007 118.845 399.007 118.845C399.007 118.845 400.839 120.274 403.013 123.245C403.976 124.57 406.491 122.893 408.209 122.324C409.928 121.765 410.642 119.704 412.671 116.857C414.699 114.01 415.238 109.299 415.238 109.299L412.64 99.6087L401.326 98.6562L393.749 105.562L393.739 105.551Z",
    fill: "#FEC4AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.432 107.259C391.11 107.953 385.634 101.275 393.542 98.6974C397.144 97.5274 404.69 91.9574 408.396 93.6036C412.101 95.2497 412.495 98.1072 412.495 98.1072C412.495 98.1072 414.606 97.3928 416.728 101.679C418.85 105.976 416.014 114.993 416.418 117.437L411.273 113.275C411.273 113.275 413.706 110.252 412.567 107.674C411.429 105.096 407.433 105.127 407.671 107.819C407.909 110.51 406.45 111.028 406.45 111.028C406.45 111.028 404.121 108.812 404.597 107.083C405.487 103.864 400.094 100.737 398.945 102.787C397.796 104.837 397.351 106.628 394.422 107.239L394.432 107.259Z",
    fill: "#471A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.593 115.635C421.117 115.676 420.765 115.676 420.62 115.635C419.295 115.293 410.994 112.602 410.994 112.602L409.42 121.961C409.42 121.961 420.651 130.13 424.626 132.117C423.405 126.661 422.349 121.174 421.583 115.625L421.593 115.635Z",
    fill: "#FEC4AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.761 114.393L415.662 129.633L419.347 132.086L423.715 115.097L419.761 114.393Z",
    fill: "#133A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.715 115.097C423.715 115.097 426.406 115.045 430.05 114.983C436.115 114.88 447.978 119.777 454.851 125.036C465.854 133.474 477.416 155.92 477.416 155.92C477.416 155.92 472.965 160.133 465.947 162.711C458.929 165.289 451.673 165.993 451.673 165.993C451.673 165.993 440.421 148.755 431.53 146.788C422.638 144.821 417.173 138.371 417.173 138.371L423.715 115.097Z",
    fill: "#133A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.426 155.92C480.562 164.089 479.91 174.4 477.416 181.793C475.408 187.735 471.464 200.294 469.29 212.511C468.017 219.665 475.252 240.03 483.129 256.885L474.569 261.544C474.569 261.544 451.414 226.922 451.414 216.683C451.414 206.444 451.683 165.994 451.683 165.994L477.426 155.93V155.92Z",
    fill: "#0F2E40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.119 256.885L487.777 265.706L476.898 272H472.157L477.964 264.567L475.728 260.374L483.119 256.885Z",
    fill: "#0F2E40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.65 157.09C479.786 165.259 478.741 175.456 476.639 182.963C474.528 190.479 455.068 212.179 453.961 218.164C451.683 230.442 442.647 259.97 442.647 259.97H432.865C432.865 259.97 438.082 226.912 438.082 216.673C438.082 206.433 450.907 167.153 450.907 167.153L476.65 157.09Z",
    fill: "#133A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.637 259.97L441.477 271.131L426.696 271.358L433.134 266.492L435.184 259.97H442.637Z",
    fill: "#133A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.986 141.435L364.456 144.376L355.689 133.712L359.219 130.771L367.986 141.435Z",
    fill: "#133A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.988 167.153L385.593 169.98C384.951 170.518 383.999 170.425 383.471 169.783L362.22 143.91C361.682 143.268 361.775 142.316 362.417 141.788L365.812 138.961C366.454 138.423 367.406 138.516 367.934 139.158L389.184 165.031C389.723 165.673 389.629 166.625 388.988 167.153Z",
    fill: "#FF3A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.005 96.1814C349.809 80.8483 333.869 73.5182 324.388 79.8233C314.906 86.1285 315.486 103.667 325.681 119.01C335.877 134.354 351.818 141.674 361.299 135.368C370.78 129.063 370.201 111.525 360.005 96.1814ZM360.43 131.186C359.695 131.672 358.887 132.014 358.049 132.273C350.255 134.727 338.258 127.904 330.298 115.925C322.338 103.946 320.692 90.2387 325.971 84.006C326.541 83.3331 327.162 82.7222 327.897 82.2356C335.411 77.2454 349.209 84.2235 358.018 97.4963C366.826 110.769 367.934 126.185 360.419 131.186H360.43Z",
    fill: "#FF3A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.028 97.4958C349.209 84.2333 335.422 77.2449 327.907 82.2351C327.172 82.7217 326.551 83.3326 325.982 84.0055C333.776 81.5518 345.773 88.3746 353.733 100.353C361.692 112.332 363.338 126.04 358.059 132.272C358.898 132.003 359.705 131.672 360.44 131.185C367.955 126.185 366.857 110.758 358.038 97.4958H358.028Z",
    fill: "#133A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.681 118.999C315.486 103.666 314.906 86.1176 324.388 79.8125L319.647 82.9702C310.165 89.2754 310.745 106.814 320.941 122.157C331.136 137.501 347.077 144.82 356.558 138.515L361.299 135.358C351.818 141.663 335.877 134.333 325.681 118.999Z",
    fill: "#133A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.789 156.013C385.789 156.013 378.161 154.553 376.432 154.946C374.714 155.34 370.015 158.321 370.015 158.321L370.718 158.735L372.395 158.622L371.132 159.533L372.126 160.382L373.337 160.04L374.942 159.968L372.82 160.899L373.834 161.521L376.194 161.241L374.662 161.976L375.283 162.773L380.873 160.816L384.392 159.367L388.491 160.175L385.779 156.002L385.789 156.013Z",
    fill: "#FEC4AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.812 118.576C420.444 117.126 417.266 120.491 417.422 132.335C417.556 142.585 416.055 151.292 416.055 151.292L385.789 156.002L385.127 161.862C385.127 161.862 415.341 162.028 421.303 162.701C427.265 163.384 428.611 144.914 429.543 136.714C430.474 128.515 430.764 120.532 424.823 118.565L424.812 118.576Z",
    fill: "#133A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.987 127.282H182.187V130.761H234.987V127.282Z",
    fill: "#C9CDD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.984 127.282H174.465V130.761H177.984V127.282Z",
    fill: "#4FAE86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.984 134.653H174.465V138.132H177.984V134.653Z",
    fill: "#4FAE86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.984 142.035H174.465V145.514H177.984V142.035Z",
    fill: "#4FAE86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.861 134.653H182.187V138.132H226.861V134.653Z",
    fill: "#C9CDD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.749 142.035H182.187V145.514H247.749V142.035Z",
    fill: "#C9CDD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.943 149.407H182.187V152.886H241.943V149.407Z",
    fill: "#C9CDD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.347 165.01H207.163V166.749H232.347V165.01Z",
    fill: "#4FAE86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.749 71.6025H233.879V80.0094H275.749V71.6025Z",
    fill: "#FF3A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.256 163.28H282.425V166.759H299.256V163.28Z",
    fill: "#4FAE86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.727 163.28H307.95V166.759H349.727V163.28Z",
    fill: "#4FAE86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 270.882H574",
    stroke: "#4E5683",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1119_35606",
    x1: 264.797,
    y1: 238.404,
    x2: 264.797,
    y2: 270.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E3EDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFE1F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1119_35606",
    x1: 252.314,
    y1: 204.124,
    x2: 252.314,
    y2: 242.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E3EDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFE1F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1119_35606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 574,
    height: 272,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorPageBackground);
export default __webpack_public_path__ + "static/media/error-page-background.35d2fa43cacadb600f0f7c3da2562b80.svg";
export { ForwardRef as ReactComponent };